import { computed } from 'mobx';

import { autobind } from 'core-decorators';
import BusinessAccountInfoStore from '@src/business-components/business-account-info';

class LoginStore {
  businessAccountInfo = new BusinessAccountInfoStore();

  @computed
  get isLogin() {
    return !!this.businessAccountInfo.username;
  }

  /**
   * Opens public XPASS login. `options` is provided by the page owner so SDK callbacks can route back without LoginStore owning business state.
   *
   * @param {object} options XPASS.signin options, such as onLoginSuccess.
   * @returns {*} XPASS.signin return value.
   */
  @autobind
  signIn(options = {}) {
    return window.XPASS.signin(options);
  }
}

export default LoginStore;
